import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ProductDetailsFormModel } from '@app/modules/product-details/models';
import { ManagementProductDetailsModel, ManagementProductDetailsSearchModel } from '../models/management/products';

@Injectable({ providedIn: 'root' })
export class ProductsDetailsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: PaginationSearchModel): Observable<PaginatedResultModel<ManagementProductDetailsSearchModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementProductDetailsSearchModel>>(
      `${environment.url.prefixCustoms}v2/management/product-details`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public get(id: number): Observable<ManagementProductDetailsModel> {
    return this.apiService.get<ManagementProductDetailsModel>(
      `${environment.url.prefixCustoms}v2/management/product-details/${id}`,
      {},
      { isShowLoader: true },
    );
  }

  public getForProduct(
    productId: number,
    params: PaginationSearchModel,
  ): Observable<PaginatedResultModel<ManagementProductDetailsSearchModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementProductDetailsSearchModel>>(
      `${environment.url.prefixCustoms}v2/management/products/${productId}/product-details`,
      { params },
      { isShowLoader: false },
    );
  }

  public create(product: ProductDetailsFormModel): Observable<ManagementProductDetailsModel> {
    return this.apiService.post<ManagementProductDetailsModel>(
      `${environment.url.prefixCustoms}v2/management/product-details`,
      product,
      {},
      { isShowLoader: true },
    );
  }

  public update(id: number, payload: ProductDetailsFormModel): Observable<void> {
    return this.apiService.put<void>(`${environment.url.prefixCustoms}v2/management/product-details/${id}`, payload);
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete<void>(`${environment.url.prefixCustoms}v2/management/product-details/${id}`);
  }
}
